import patterns from "./patterns";

const FIELD_TYPE = {
  TEXT: "text",
  TEXTAREA: "textarea",
  NUMBER: "number",
  DATE: "date",
  DATETIME: "datetime",
  HTML: "html",
  SELECT: "select",
  MULTIPLE_SELECT: "multiple_select",
  RATIO: "ratio",
  CHECKBOX: "checkbox",
  FILE_IMAGES: "file_images",
  FILE_VIDEOS: "file_videos",
  FILE_AUDIOS: "file_audios",
  FILE_OTHERS: "file_others",
  LINK_3DS: "link_3ds",
  LINK_YOUTUBE: "link_youtube",
  MODULE: "module"
};

const DATA_TYPE = {
  ANY: null,
  EMAIL: "email",
  PHONE: "phone",
  LINK: "link",
};

const FILE_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio",
  OTHER: "other",
};

export const ROLE_ACTION_METHODS = {
  READ: "read",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete"
}

export const ROLE_ACTIONS = {
  // Common
  APPROVED_ORDER: "approved_order",
  MANAGEMENT_LOG: "management_log",
  ORDER_STATUS: "order_status",
  ARTIFACT: "artifact",
  NOTABLE: "notable",
  DOCUMENT: "document",
  EVENT: "event",
  EXTRA: "extra",
  CATEGORY: "category",
  FILE: "file",
  TAG: "tag",
  // Auth
  ACCOUNT_MANAGEMENT: "account-management",
  // Fixed
  REPORT_HANDLING: "report-handling",
  CREATE_ACCOUNT: "create-account",
  // Setting
  ORGANIZATION_SETTING: "organization_setting",
  MANAGEMENT_ROLE: "management_role",
  MANAGEMENT_ROLE_USER: "management_role_user",
  // Feature
  CONTRACT: "contract",
  CONTRACT_STEP: "contract_step",
  CONTRACT_ACTION: "contract_action",
  APPROVE_DOCUMENT: "approve_document",
}

export const GROUP_KEYS = {
  DASHBOARD: 'dashboard',
  CONFIG_OTHERS: 'config-others',
  CATEGORIES: 'categories',
  APPROVED_DOCUMENTS: 'approved-documents',
  MANAGE: 'manage',
  LOG: 'log',
  OTHER: 'other'
}

export default {
  APP_TITLE: "Quản lý hiện vật",
  HOTLINE: "0123456789",
  EDITOR_API_KEY: "1oo1lu0sbcnrznvh20hr6tatwezj2zflplh17eataa0p4kft",
  FIELD_TYPE,
  FILE_TYPE,
  PAGE_SIZE: 50,
  OBJECT_TYPES: [
    {
      value: "artifacts",
      label: "Hiện vật",
      role_action: ROLE_ACTIONS.ARTIFACT,
      count: 100000
    },
    {
      value: "notables",
      label: "Nhân vật",
      role_action: ROLE_ACTIONS.NOTABLE,
      count: 80000
    },
    {
      value: "documents",
      label: "Media",
      role_action: ROLE_ACTIONS.DOCUMENT,
      count: 50000
    },
    {
      value: "events",
      label: "Sự kiện",
      role_action: ROLE_ACTIONS.EVENT,
      count: 10000
    },
    {
      value: "categories",
      label: "Danh mục",
      role_action: ROLE_ACTIONS.CATEGORY,
      count: 40000
    },
    {
      value: "tags",
      label: "Thẻ Tag",
      role_action: ROLE_ACTIONS.TAG,
      count: 50
    },
  ],
  ALL_ACTIONS: [
    {
      label: "Xem chi tiết",
      key: "view",
      icon: "el-icon-view",
      type: "primary",
    },
    {
      label: "Xem mã QRCode",
      key: "showQR",
      icon: "fas fa-qrcode",
      type: "info",
      hide: true,
    },
    {
      label: "Danh sách liên kết",
      key: "connection",
      icon: "el-icon-connection",
      type: "default",
    },
    {
      label: "Chi tiết",
      key: "detail",
      icon: "el-icon-document",
      type: "primary",
      hide: true,
    },
    {
      label: "Cấu hình",
      key: "config",
      icon: "el-icon-setting",
      type: "primary",
      plain: true,
      hide: true,
    },
    {
      label: "Thẻ tags",
      key: "tag",
      icon: "el-icon-collection-tag",
      type: "primary",
      plain: true,
    },
    {
      label: "Chỉnh sửa",
      key: "edit",
      icon: "el-icon-edit",
      type: "primary",
    },
    {
      label: "Xóa",
      key: "delete",
      icon: "el-icon-delete",
      type: "danger",
    },
  ],
  FIELD_TYPES: [
    {
      key: FIELD_TYPE.TEXT,
      label: "Input",
      description: "Chuỗi ký tự ngắn",
      default: "",
    },
    {
      key: FIELD_TYPE.TEXTAREA,
      label: "Texarea",
      description: "Chuỗi ký tự dài",
      default: "",
    },
    {
      key: FIELD_TYPE.NUMBER,
      label: "Number",
      description: "Một số",
      default: 0,
    },
    {
      key: FIELD_TYPE.DATE,
      label: "Date",
      description: "Một ngày",
      default: null,
    },
    {
      key: FIELD_TYPE.DATETIME,
      label: "Date Time",
      description: "Một thời gian",
      default: null,
    },
    {
      key: FIELD_TYPE.HTML,
      label: "Html",
      description: "Nội dung html",
      default: "",
    },
    {
      key: FIELD_TYPE.SELECT,
      label: "Select",
      description: "Select một giá trị từ list",
      default: null,
    },
    {
      key: FIELD_TYPE.RATIO,
      label: "Ratio",
      description: "Click chọn một giá trị từ list",
      default: null,
    },
    {
      key: FIELD_TYPE.CHECKBOX,
      label: "Checkbox",
      description: "Click chọn một hoặc nhiều giá trị từ list",
      default: [],
    },
    {
      key: FIELD_TYPE.MULTIPLE_SELECT,
      label: "Select Multiple",
      description: "Select một hoặc nhiều giá trị từ list",
      connect_category: true,
      default: [],
    },
    {
      key: FIELD_TYPE.FILE_IMAGES,
      label: "File Images",
      description: "Danh sách ảnh",
      default: [],
    },
    {
      key: FIELD_TYPE.FILE_VIDEOS,
      label: "File Videos",
      description: "Danh sách Video",
      default: [],
    },
    {
      key: FIELD_TYPE.FILE_AUDIOS,
      label: "File Audios",
      description: "Danh sách Audio",
      default: [],
    },
    {
      key: FIELD_TYPE.FILE_OTHERS,
      label: "File khác (doc, excel, pdf, csv...)",
      description: "Danh sách file khác",
      default: [],
    },
    {
      key: FIELD_TYPE.LINK_3DS,
      label: "Link 3Ds",
      description: "Danh sách link 3D",
      default: [],
    },
    {
      key: FIELD_TYPE.LINK_YOUTUBE,
      label: "Link Youtube",
      description: "Danh sách link Youtube",
      default: [],
    },
  ],
  DATA_TYPES: [
    {
      key: DATA_TYPE.ANY,
      pattern: null,
      label: "Mặc định",
    },
    {
      key: DATA_TYPE.EMAIL,
      pattern: patterns.EMAIL,
      label: "Địa chỉ Email",
    },
    {
      key: DATA_TYPE.PHONE,
      pattern: patterns.PHONE,
      label: "Số điện thoại",
    },
    {
      key: DATA_TYPE.LINK,
      pattern: patterns.LINK,
      label: "Link",
    },
  ],
  FILE_TYPES: [
    {
      key: FILE_TYPE.IMAGE,
      accept: "image/*",
      label: "Hình ảnh",
    },
    {
      key: FILE_TYPE.VIDEO,
      accept: "video/*",
      label: "Video",
    },
    {
      key: FILE_TYPE.AUDIO,
      accept: "audio/*",
      label: "Audio",
    },
    {
      key: FILE_TYPE.OTHER,
      accept: ".doc,.docx,.pdf,.xls,.xlsx,.xml",
      label: "Loại khác",
    },
  ],
  BLOCK_KEYS: [
    "id",
    "avatar_url",
    "code",
    "created",
    "creator_id",
    "deleted",
    "extra",
    "extra_en",
    "extra_ch",
    "extra_kr",
    "locales",
    "ordered",
    "organization_id",
    "register_at",
    "tag_ids",
    "type",
    "updated",
    "relations",
    "packages"
  ],
  DOCUMENT_TYPE_ACTION_METHODS: [
    {
      key: ROLE_ACTION_METHODS.READ,
      label: "Xem",
      type: "info"
    },
    {
      key: ROLE_ACTION_METHODS.CREATE,
      label: "Thêm",
      type: "success"
    },
    {
      key: ROLE_ACTION_METHODS.UPDATE,
      label: "Sửa",
      type: "warning"
    },
    {
      key: ROLE_ACTION_METHODS.DELETE,
      label: "Xóa",
      type: "danger"
    }
  ],
  DOCUMENT_TYPE_ACTIONS: [
    // Common
    {
      key: ROLE_ACTIONS.APPROVED_ORDER,
      label: "Phê duyệt nội dung",
      group: "common",
      coming_soon: true
    },
    {
      key: ROLE_ACTIONS.MANAGEMENT_LOG,
      label: "Quản lý log",
      group: "common",
      coming_soon: true
    },
    {
      key: ROLE_ACTIONS.ORDER_STATUS,
      label: "Trạng thái nội dung",
      group: "common",
      coming_soon: true
    },
    {
      key: ROLE_ACTIONS.ARTIFACT,
      label: "Quản lý hiện vật",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.NOTABLE,
      label: "Quản lý nhân vật",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.EVENT,
      label: "Quản lý triển lãm, sự kiện",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.DOCUMENT,
      label: "Quản lý tài liệu",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.EXTRA,
      label: "Quản lý đối tượng khác",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.CATEGORY,
      label: "Quản lý danh mục",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.FILE,
      label: "Quản lý media",
      group: "common",
    },
    {
      key: ROLE_ACTIONS.TAG,
      label: "Quản lý thẻ Tag",
      group: "common",
    },
    // Setting
    {
      key: ROLE_ACTIONS.MANAGEMENT_ROLE_USER,
      label: "Quản lý tài khoản",
      group: "settings",
      methods: [
        ROLE_ACTION_METHODS.READ,
        ROLE_ACTION_METHODS.UPDATE,
        ROLE_ACTION_METHODS.DELETE
      ]
    },
    {
      key: ROLE_ACTIONS.MANAGEMENT_ROLE,
      label: "Quản lý quyền hạn",
      group: "settings"
    },
    // Auth
    {
      key: ROLE_ACTIONS.ACCOUNT_MANAGEMENT,
      label: "Thông tin tài khoản",
      group: "auth",
      methods: [
        ROLE_ACTION_METHODS.READ,
        ROLE_ACTION_METHODS.UPDATE
      ]
    },
    // Fixed
    {
      key: ROLE_ACTIONS.CREATE_ACCOUNT,
      label: "Tạo tài khoản mới",
      group: "fixed",
      methods: [
        ROLE_ACTION_METHODS.CREATE
      ]
    },
    {
      key: ROLE_ACTIONS.REPORT_HANDLING,
      label: "Báo cáo",
      group: "fixed",
      methods: [
        ROLE_ACTION_METHODS.READ,
      ]
    },
  ],
};

export const DEFAULT_PACKAGES = [
  {
    code: "1_day",
    label: "1 Ngày",
    price: 2000,
    hide: true,
  },
  {
    code: "1_week",
    label: "7 Ngày",
    price: 10000,
    hide: false,
  },
  {
    code: "1_month",
    label: "1 Tháng",
    price: 30000,
    hide: false,
  },
  {
    code: "3_month",
    label: "3 Tháng",
    price: 50000,
    hide: true,
  },
  {
    code: "6_month",
    label: "6 Tháng",
    price: 80000,
    hide: true,
  },
  {
    code: "1_year",
    label: "1 Năm",
    price: 100000,
    hide: false,
  },
  {
    code: "lifetime",
    label: "Trọn đời",
    price: 300000,
    hide: true,
  },
];
